import { IMobileHome } from 'mhbo-js'
import React, { Suspense } from 'react'
import { IntlProvider } from 'react-intl'
import NO_PHOTO from '../../../assets/no_photo.png'
import FavoriteIcon from './FavoriteIcon'
import Flags from './Flags'

const RentOrBuyFooter = React.lazy(() => import('./RentOrBuyFooter'))
const RentFooter = React.lazy(() => import('./RentFooter'))
const BuyFooter = React.lazy(() => import('./BuyFooter'))

interface IProps {
  homeListing: IMobileHome
  onClick: () => void
  onMouseOver?: () => void
  onMouseOut?: () => void
  isFavorite: boolean
  favid: number
  isLazy: boolean
}

const HomePreviewCell: React.FC<IProps> = (props: IProps) => {
  const {
    homeListing,
    onClick,
    onMouseOver,
    isFavorite,
    favid,
    onMouseOut,
    isLazy,
  } = props
  const { photoLarge, featured, askingPrice, sellerTypeId, id, rentalPrice } =
    homeListing
  const photo = photoLarge === '' ? NO_PHOTO : photoLarge

  return (
    <IntlProvider locale="en">
      <div
        className="listingCell__preview_cell"
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onClick={onClick}
      >
        <img
          alt=""
          src={photo}
          className="listingCell__preview_cell_image"
          loading={isLazy ? 'lazy' : 'eager'}
        />
        <div className="listingCell__preview_cell_header">
          <Flags
            isFeatured={featured}
            askingPrice={askingPrice}
            sellerTypeId={sellerTypeId}
            rentalPrice={rentalPrice}
          />
          <FavoriteIcon
            isFavorite={isFavorite}
            id={id}
            type="MobileHome"
            favid={favid}
          />
        </div>
        <Suspense fallback={null}>
          {askingPrice && rentalPrice ? (
            <RentOrBuyFooter homeListing={homeListing} />
          ) : rentalPrice ? (
            <RentFooter homeListing={homeListing} />
          ) : (
            <BuyFooter homeListing={homeListing} />
          )}
        </Suspense>
      </div>
    </IntlProvider>
  )
}

export default HomePreviewCell
